import VisibleOn, { HiddenOn } from './visible-on';
export { HiddenOn };
export default VisibleOn;
